<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Q&A</h1>
      <!-- <p class="mt-16">For all our friends and family who have lots of questions, have a look here!</p> -->
      <div class="flex flex-row justify-center">
        <img src="https://withjoy.com/media/ea2d0ea6d5be9f535f403cfdb5e3515862d4085be61d8939e/44018080-ec2c-11ef-9f74-ed241fce351f-IMG_8996.jpeg?rendition=medium" class="my-16 max-w-md">
      </div>
      <div class="text-left">
        <h3 class="mt-16">When is the RSVP deadline?</h3>
        <p>Please RSVP by 31st August 2025, so we can have an accurate headcount.</p>
        <h3 class="mt-16">Can I bring a date?</h3>
        <p>Please check your RSVP for your +1!</p>
        <h3 class="mt-16">Are kids welcome?</h3>
        <p>As much as we love your little ones, we will not be including them in the ceremony or reception.</p>
        <h3 class="mt-16">Do you have a gift registry?</h3>
        <p>The greatest gift is your presence at our wedding. If you wish to give a gift, we would be grateful for a monetary contribution as we build our life together.</p>
        <h3 class="mt-16">What will the weather be like?</h3>
        <p>February is one of the best time to visit the Philippines as the weather is dry, sunny, and comfortably warm, with temperatures ranging from 24°C to 31°C. Rain is minimal, humidity is lower, and typhoons are rare, making it a great time for travel and outdoor activities!</p>
        <h3 class="mt-16">Where should I park?</h3>
        <p>There's a free car park around the church and near the reception.</p>
        <h3 class="mt-16">What should I wear?</h3>
        <p>Please see our Attire page for the dress code.</p>
        <h3 class="mt-16">Is it okay to take pictures with our phones and cameras during the wedding?</h3>
        <p>Yes! We would love for you to take photos and share them on the link that we will provide on the wedding day. However, please refrain from taking photos during the ceremony.</p>
        <h3 class="mt-16">Whom should I call with questions?</h3>
        <p>Please leave us a message at hello@ellakhanh.com, or send us a message on WhatsApp or Messenger.</p>
      </div>
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'QuestionsPage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>